import { lazy } from "react";
import { validateTidalLicense } from "../../base/index.js";
function smartLazy(loader) {
  return new Proxy({}, {
    get: (_target, componentName) => {
      if (typeof componentName === "string") {
        return lazy(
          () => loader(componentName).then((x) => ({
            default: x[componentName]
          }))
        );
      }
    }
  });
}
validateTidalLicense();
export {
  smartLazy
};
//# sourceMappingURL=smartLazy.js.map
